import { Component, ChangeDetectorRef, ChangeDetectionStrategy, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { PacerManagerService } from '~/services/pacer-manager';
import { ThemeManagerService } from '~/services/theme-manager';

@Component({
    selector: 'asap-loader',
    templateUrl: './loader.html',
    styleUrls: ['./loader.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'asap-loader',
    },
    standalone: false
})
export class LoaderComponent implements OnInit {
  _loadingMessage: string = 'Please wait, we are processing your request.';
  _timeIntervalMessages: any[] = [];
  _savingMode: boolean;

  @Input() withPopup: boolean = true;
  @Input() size: 'small' | 'medium' | 'large' | null = 'large';
  @Input() themeColor: 'primary' | 'secondary' | 'dark' | 'light' | null =
    'secondary';

  constructor(
    private _pacerManager: PacerManagerService,
    private _themeManager: ThemeManagerService,
    private _cdr: ChangeDetectorRef) {


    this._pacerManager.modeChanges.subscribe((x) => {

      if (x == undefined || x == null) {
        this._savingMode = false;
      }
      else if (x.mode === 'saving') {
        this._savingMode = true;
      }
      /* }
      else{
        this._savingMode = false ;
      } */


      if (!this._timeIntervalMessages.length) {
        if (x != undefined && x != null) {
          if (x.message === null) {
            this.initMessages(x.message);
          }
          else
            this._loadingMessage = x.message;

          this._cdr.markForCheck();
        }
        else {
          this.initMessages();
        }

      }
    });

    this._pacerManager.pacingChanges.subscribe((x) => {
      if (!x) {
        this.clearTimeout();
      }
    });

    this._themeManager.themeChange.subscribe((data) => {
      this.themeColor = data === 'dark' ? 'light' : 'secondary';
    });
  }

  ngOnInit() {

  }

  private initMessages(custommessage: any = null) {
    this._timeIntervalMessages[0] = setTimeout(() => {
      this._loadingMessage = 'Processing... We appreciate your patience.';
      this._cdr.markForCheck();
    }, 20);
    this._timeIntervalMessages[1] = setTimeout(() => {
      this._loadingMessage = 'Please wait, your request is still processing.';
      this._cdr.markForCheck();
    }, 20);
    this._timeIntervalMessages[2] = setTimeout(() => {
      this._loadingMessage = 'Please wait, your data is uploading.';
      this._cdr.markForCheck();
    }, 20);
    this._timeIntervalMessages[3] = setTimeout(() => {
      this._loadingMessage = 'Uploading... We appreciate your patience.';
      this._cdr.markForCheck();
    }, 20);
    this._timeIntervalMessages[4] = setTimeout(() => {
      this._loadingMessage = 'Please wait, we are finalizing your request.';
      this._cdr.markForCheck();
    }, 20);
    this._timeIntervalMessages[5] = setTimeout(() => {
      this._loadingMessage = custommessage === null ? 'Almost done! We appreciate your patience.' : custommessage;
      this._cdr.markForCheck();
    }, 20);

  }

  private clearTimeout() {
    this._timeIntervalMessages.forEach((x) => {
      clearTimeout(x);
    });
    this._timeIntervalMessages = [];
  }
}
